import type { Testimonial } from '@/types';

export const testimonials: Testimonial[] = [
  {
    id: 'milica-jovanovic',
    name: 'Milica Jovanović',
    role: 'Direktorka operacija',
    company: 'Northline Group',
    quote:
      'Pre početka nismo imali jedinstven pregled obaveza između tri tima. Posle prvog meseca imali smo plan, odgovorne osobe i redovan status koji svi koriste.',
    rating: 5
  },
  {
    id: 'marko-petrovic',
    name: 'Marko Petrović',
    role: 'Osnivač',
    company: 'Forma Studio',
    quote:
      'Sastanci su postali kraći jer se otvorena pitanja beleže i pripreme unapred. Tačno znamo ko donosi odluku i do kada.',
    rating: 5
  },
  {
    id: 'ana-nikolic',
    name: 'Ana Nikolić',
    role: 'Project Lead',
    company: 'Vertex Systems',
    quote:
      'Dobili smo jasnu strukturu projekta i dokumentaciju koju naš tim i dalje koristi. Komunikacija je bila kratka, precizna i redovna.',
    rating: 5
  },
  {
    id: 'nikola-stojanovic',
    name: 'Nikola Stojanović',
    role: 'Direktor razvoja',
    company: 'Atria Works',
    quote:
      'Najviše nam je značilo što smo rizike videli pre nego što su postali problem. Plan se menjao, ali pregled nad projektom nije nestao.',
    rating: 5
  },
  {
    id: 'jelena-ilic',
    name: 'Jelena Ilić',
    role: 'COO',
    company: 'Motive Labs',
    quote:
      'Helmflex je povezao operativu i menadžment bez dodatne administracije. Svaki status je završavao jasnom odlukom i sledećim korakom.',
    rating: 5
  },
  {
    id: 'luka-popovic',
    name: 'Luka Popović',
    role: 'Product Manager',
    company: 'Nexa Digital',
    quote:
      'Uveli smo novi način praćenja rada bez prekida tekućih projekata. Tim ga je prihvatio jer je jednostavan i prilagođen našem procesu.',
    rating: 5
  },
  {
    id: 'sara-kovacevic',
    name: 'Sara Kovačević',
    role: 'Direktorka prodaje',
    company: 'Orbis Commerce',
    quote:
      'Od nejasnog zahteva stigli smo do realnog plana koji su i prodaja i operativa mogle da prate. Rokovi su konačno imali vlasnike.',
    rating: 5
  },
  {
    id: 'stefan-ristic',
    name: 'Stefan Ristić',
    role: 'Osnivač',
    company: 'Konstrukt Studio',
    quote:
      'Dobili smo upravo ono što nam je nedostajalo: mirnu koordinaciju, kratke izveštaje i rano upozorenje kada nešto skrene sa plana.',
    rating: 5
  }
];
